module.exports = __webpack_public_path__ + "media/audio34.4bde6c5a.mp3";